const maping = {
  index: {
    title: '上海及时雨小额贷款官网',
    metaTags: [
      {
        name: 'description',
        content: '上海嘉定及时雨小贷于2013年3月成立，经上海市政府批准设立，注册资本金2亿元。公司服务于机构和小微企业客户。连续多年被评为中国百强小贷公司及上海市金融监管A类小贷公司。',
      },
      {
        name: 'keywords',
        content: '上海嘉定及时雨小额贷款_上海及时雨小额贷款官网_贷款_小额贷款_过桥贷_企业贷_赎楼贷_上海及时雨_小额贷款官网_及时雨小贷_及时雨',
      },
    ]
  },
  progress : {//发展历程
    title: '发展历程-上海及时雨小额贷款官网',
    metaTags: [
      {
        name: 'description',
        content: '上海嘉定及时雨小贷于2013年3月成立，经上海市政府批准设立，注册资本金2亿元。公司服务于机构和小微企业客户。连续多年被评为中国百强小贷公司及上海市金融监管A类小贷公司。',
      },
      {
        name: 'keywords',
        content: '上海嘉定及时雨小额贷款_上海及时雨小额贷款官网_贷款_小额贷款_过桥贷_企业贷_赎楼贷_上海及时雨_小额贷款官网_及时雨小贷_及时雨',
      },
    ]
  },
  aboutUs:{//公司介绍
    title: '   ',
    metaTags: [
    ]
  },
  award : {
    title: '企业荣誉-上海及时雨小额贷款官网',
    metaTags: [
      {
        name: 'description',
        content: '上海嘉定及时雨小贷于2013年3月成立，经上海市政府批准设立，注册资本金2亿元。公司服务于机构和小微企业客户。连续多年被评为中国百强小贷公司及上海市金融监管A类小贷公司。',
      },
      {
        name: 'keywords',
        content: '上海嘉定及时雨小额贷款_上海及时雨小额贷款官网_贷款_小额贷款_过桥贷_企业贷_赎楼贷_上海及时雨_小额贷款官网_及时雨小贷_及时雨',
      },
    ]
  },
  customer : {
    title: '客户故事-上海及时雨小额贷款官网',
    metaTags: [
      {
        name: 'description',
        content: '上海嘉定及时雨小贷于2013年3月成立，经上海市政府批准设立，注册资本金2亿元。公司服务于机构和小微企业客户。连续多年被评为中国百强小贷公司及上海市金融监管A类小贷公司。',
      },
      {
        name: 'keywords',
        content: '上海嘉定及时雨小额贷款_上海及时雨小额贷款官网_贷款_小额贷款_过桥贷_企业贷_赎楼贷_上海及时雨_小额贷款官网_及时雨小贷_及时雨',
      },
    ]
  },
  news : {
    title: '资讯动态-上海及时雨小额贷款官网',
    metaTags: [
      {
        name: 'description',
        content: '上海嘉定及时雨小贷于2013年3月成立，经上海市政府批准设立，注册资本金2亿元。公司服务于机构和小微企业客户。连续多年被评为中国百强小贷公司及上海市金融监管A类小贷公司。',
      },
      {
        name: 'keywords',
        content: '上海嘉定及时雨小额贷款_上海及时雨小额贷款官网_贷款_小额贷款_过桥贷_企业贷_赎楼贷_上海及时雨_小额贷款官网_及时雨小贷_及时雨',
      },
    ]
  },
  contact : {
    title: '联系我们-上海及时雨小额贷款官网',
    metaTags: [
      {
        name: 'description',
        content: '上海嘉定及时雨小贷于2013年3月成立，经上海市政府批准设立，注册资本金2亿元。公司服务于机构和小微企业客户。连续多年被评为中国百强小贷公司及上海市金融监管A类小贷公司。',
      },
      {
        name: 'keywords',
        content: '上海嘉定及时雨小额贷款_上海及时雨小额贷款官网_贷款_小额贷款_过桥贷_企业贷_赎楼贷_上海及时雨_小额贷款官网_及时雨小贷_及时雨',
      },
    ]
  },
  questions:{
    title: '常见问题-上海及时雨小额贷款官网',
    metaTags: [
      {
        name: 'description',
        content: '上海嘉定及时雨小贷于2013年3月成立，经上海市政府批准设立，注册资本金2亿元。公司服务于机构和小微企业客户。连续多年被评为中国百强小贷公司及上海市金融监管A类小贷公司。',
      },
      {
        name: 'keywords',
        content: '上海嘉定及时雨小额贷款_上海及时雨小额贷款官网_贷款_小额贷款_过桥贷_企业贷_赎楼贷_上海及时雨_小额贷款官网_及时雨小贷_及时雨',
      },
    ]
  },
  empty:{
    title: '  ',
    metaTags: [
    ]
  },
};

export default maping;



// WEBPACK FOOTER //
// ./src/router/meta.js